<mat-menu #menu class="global-menu">
  <ng-container *ngFor="let item of items">
    <a mat-menu-item
      *ngIf="!item.menuChildrenOutput.length; else branch"
      [routerLink]="item.url"
      routerLinkActive="active">
        <i [class]="item.icone + ' mr-2'"></i>
        {{item.nomeExibicao}}
  </a>
    <ng-template #branch>
      <button mat-menu-item
        [matMenuTriggerFor]="innerPanel.menu">
          <i [class]="item.icone + ' mr-2'"></i>
          {{item.nomeExibicao}}
      </button>
      <app-menu-panel #innerPanel [items]="item.menuChildrenOutput"></app-menu-panel>
    </ng-template>
  </ng-container>
</mat-menu>
